module.exports = __webpack_public_path__ + "img/main-data-ioc02.c3127644.png";